import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IItemForGetShortDishInfo, IGetDishesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getDishesShortBySubCategoryIdV2 } from 'backend/dishes';
import { MultipleSelect } from './MultipleSelect';
import style from './index.module.scss';

interface IProps {
	setFetchedModificationDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	setFetchedModificationDishes: (value: IItemForGetShortInfo[]) => void;
	setModificationDishCategory: (value: Nullable<string>) => void;
	setModificationDishSubCategory: (value: Nullable<string>) => void;
	setModificationDishes: (value: string[]) => void;
	removeModificationDish: (value: string) => void;
	IDsSelectedRestaurant: string[];
	selectedModificationDishCategory: Nullable<string>;
	selectedModificationDishSubCategory: Nullable<string>;
	fetchedModificationDishes: IItemForGetShortDishInfo[];
	selectedModificationDishes: string[];
}

export const ModificationDishMultipleSelect: React.FC<IProps> = React.memo(
	({
		setFetchedModificationDishSubCategories,
		setFetchedModificationDishes,
		setModificationDishCategory,
		setModificationDishSubCategory,
		setModificationDishes,
		removeModificationDish,
		IDsSelectedRestaurant,
		selectedModificationDishCategory,
		selectedModificationDishSubCategory,
		fetchedModificationDishes,
		selectedModificationDishes,
	}) => {
		const { response, loading, refetch, responseError } = useFetchData<IGetDishesShort, string>(
			selectedModificationDishSubCategory ? getDishesShortBySubCategoryIdV2 : null,
			selectedModificationDishSubCategory || '',
		);

		useEffect(() => {
			refetch();
		}, [selectedModificationDishSubCategory]);

		useEffect(() => {
			if (response) {
				const dishes = response.data.dishes.map((dish) => ({ ...dish, externalId: null }));
				setFetchedModificationDishes(dishes);
			}
		}, [response]);

		return (
			<div className={style.container}>
				<div className={style.field}>
					<MultipleSelect
						refetch={refetch}
						setFetchedModificationDishSubCategories={setFetchedModificationDishSubCategories}
						setModificationDishCategory={setModificationDishCategory}
						setModificationDishSubCategory={setModificationDishSubCategory}
						setModificationDishes={setModificationDishes}
						removeModificationDish={removeModificationDish}
						data={
							selectedModificationDishSubCategory && response?.data.dishes && !loading
								? response.data.dishes
								: []
						}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
						selectedModificationDishCategory={selectedModificationDishCategory}
						selectedModificationDishSubCategory={selectedModificationDishSubCategory}
						fetchedModificationDishes={fetchedModificationDishes}
						selectedModificationDishes={selectedModificationDishes}
						isLoading={loading}
						responseError={responseError}
					/>
				</div>
			</div>
		);
	},
);
